import { render, staticRenderFns } from "./AccessoryPopin.vue?vue&type=template&id=dbc35cd8&"
import script from "./AccessoryPopin.vue?vue&type=script&lang=js&"
export * from "./AccessoryPopin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbc35cd8')) {
      api.createRecord('dbc35cd8', component.options)
    } else {
      api.reload('dbc35cd8', component.options)
    }
    module.hot.accept("./AccessoryPopin.vue?vue&type=template&id=dbc35cd8&", function () {
      api.rerender('dbc35cd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/AccessoryPopin.vue"
export default component.exports